<template>
  <div class="per-page">
    <v-select
      name="perPageSelect"
      v-bind="$attrs"
      v-on="$listeners"
      return-object
      item-text="name"
      :hide-details="true"
      dense
      outlined
      item-value="value"
      append-icon="icon-arrow-down"
      class="per-page-select"
      full-width
    ></v-select>
  </div>
</template>

<script>
export default {
  name: "PerPageSelect",
  inheritAttrs: false
};
</script>

<style lang="scss">
.per-page {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: $spacing * 2.5;
  max-width: 150px;
}

.per-page-select {
  width: 100%;
  flex-shrink: 0;

  &.v-text-field--outlined.v-input--dense.v-text-field--outlined {
    > .v-input__control {
      > .v-input__slot {
        padding-left: $spacing;
        padding-right: 0;
        min-height: 46px;
        height: 46px;
        @include font-size(14px);
        line-height: 17px;
        font-weight: normal;
      }
    }

    fieldset {
      border-color: rgba($text, 0.08);
      border-width: 1px;
      border-radius: $container-border-radius;
    }
  }

  &.v-text-field--outlined.v-input--dense.v-input--is-focused fieldset {
    border-color: $primary;
  }

  &.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
    .v-input__append-inner {
    width: 30px;
    margin-top: auto;
    margin-bottom: auto;
    margin-right: $spacing * 1.5;
    padding-left: $spacing;
  }

  .v-select__selection--comma {
    margin-left: $spacing * 1.5 !important;
  }
}
</style>
